/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'yes' }, { id: 'absolutely' }, { id: 'probably' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-would-try"
      progress={68}
      field="hairstyleWouldTry"
      setter="setHairstyleWouldTry"
      ns="hairstyleWouldTry"
      imageName="hairstyleWouldTry"
      options={OPTIONS}
    />
  );
}

export default Page;
